import React, { useEffect, useState } from 'react';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';

type Props = {
    title?: string;
    name: any;
    answerQuestion?: any;
    onChange: (value: any) => void;
    idQuestion?: string;
    required?: boolean;
    questionType?: string;
    questionIcon?: string;
    whyQuestion?: boolean;
    disabled?: boolean;
    dominantColor?: string;
};

const FieldLinealAnswer = ({
    title,
    name,
    answerQuestion,
    onChange,
    idQuestion,
    required = true,
    questionType,
    whyQuestion,
    disabled,
    dominantColor,
}: Props) => {
    const numbers: any = [];
    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState(false);
    const [helperText, setHelperText] = React.useState('');
    const [why, setWhy] = useState('');
    const [touched, setTouched] = useState(false);
    const [initialValueRange, finalValueRange] = answerQuestion?.range.split(
        '-'
    ) || ['0', '0'];

    if (initialValueRange <= finalValueRange) {
        for (let i = initialValueRange; i <= finalValueRange; i++) {
            numbers.push(i);
        }
    } else {
        for (let i = initialValueRange; i >= finalValueRange; i--) {
            numbers.push(i);
        }
    }

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
        setHelperText(' ');
        setError(false);
        setTouched(true);
    };

    useEffect(() => {
        const isEmpty = value.length === 0;

        if (isEmpty && touched && required) {
            setHelperText('La respuesta es obligatoria');
            setError(true);
        } else {
            setError(false);
        }

        onChange({
            idQuestion,
            [name]: value,
            type: questionType,
            why: why,
            error: required && isEmpty,
        });
    }, [value, touched, why, required]);

    return (
        <>
            <Grid item xs={12} key={idQuestion}>
                <LabelAnswer
                    text={title}
                    isRequired={required}
                    dominantColor={dominantColor}
                />
                <br />
                {answerQuestion?.label && (
                    <>
                        <Grid item xs={12}>
                            <LabelAnswer
                                text={answerQuestion.label}
                                isRequired={false}
                                dominantColor={dominantColor}
                                isOptional={true}
                            />
                        </Grid>
                        <br />
                    </>
                )}
                <FormControl error={error} fullWidth>
                    <Grid
                        display="flex"
                        justifyContent="center"
                        overflow="hidden"
                    >
                        <RadioGroup
                            row
                            onChange={handleRadioChange}
                            sx={{
                                border: error
                                    ? '1px solid #d32f2f'
                                    : '1px solid #E0E0E0',
                                borderRadius: '4px',
                                width: '80%',
                                '.MuiFormHelperText-root': {
                                    textAlign: 'center',
                                },
                            }}
                        >
                            <Grid
                                display="flex"
                                flexWrap="wrap"
                                justifyContent="center"
                                width="100%"
                            >
                                {numbers.map((n: number) => (
                                    <FormControlLabel
                                        key={n}
                                        value={n}
                                        control={
                                            <Radio
                                                sx={{
                                                    color:
                                                        dominantColor || '#36c',
                                                    '&.Mui-checked': {
                                                        color:
                                                            dominantColor ||
                                                            '#36c',
                                                    },
                                                }}
                                            />
                                        }
                                        label={n}
                                        labelPlacement="top"
                                        sx={{
                                            backgroundColor: '#D1E2FF8C',
                                            margin: 0,
                                            padding: 0,
                                            justifyContent: 'center',
                                            width: '10%',
                                            minWidth: '50px',
                                            boxSizing: 'border-box',
                                        }}
                                        slotProps={{
                                            typography: {
                                                fontFamily: 'Lucida Sans',
                                                textAlign: 'center',
                                                fontSize: '15px',
                                                color: '#4b4b4b',
                                                bgcolor: '#FFF',
                                                width: '100%',
                                            },
                                        }}
                                        disabled={disabled ?? false}
                                    />
                                ))}
                            </Grid>
                        </RadioGroup>
                    </Grid>
                    <FormHelperText sx={{ textAlign: 'center' }}>
                        {helperText}
                    </FormHelperText>
                </FormControl>
            </Grid>
            {whyQuestion && value && (
                <Grid item xs={12}>
                    <LabelAnswer
                        text="¿Por qué?"
                        isRequired={false}
                        dominantColor={dominantColor}
                    />
                    <br />
                    <FieldTextAreaAutoSize
                        name="why"
                        placeholder="Dejanos aquí las razones de porque"
                        required={false}
                        onChange={(e: any) => setWhy(e.target.value)}
                        dominantColor={dominantColor}
                    />
                </Grid>
            )}
        </>
    );
};

export default FieldLinealAnswer;
